/* global modelUrl modelName budgetIsLocked processAjaxConfirmation selectedVenueId packsDashboardUrl */

import React, { useCallback, useContext, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import { ApiProvider, PacksContext, PacksDispatchContext } from './ApiProvider';
import { AssignProvider } from './AssignProvider';
import ContractorPacks from './ContractorPacks';
import Popup from './Popup';
import SimplePacks from './SimplePacks';

import Button from 'CommonComponents/Button';

import './packs.css';

const defaultActionObject = () => {
    return {
        action: null,
        itemType: null,
        itemId: null,
        toType: null,
        toId: null,
        fromType: null,
        fromId: null,
    };
};

export default function ExpensePackApp(props) {
    const [processedAction, setProcessedAction] = useState(defaultActionObject());

    return (
        <div className="tw-flex tw-flex-col tw-h-full">
            <ApiProvider processedAction={processedAction} setProcessedAction={setProcessedAction}>
                <AssignProvider event={props.event} selectedVenueId={props.selectedVenueId}>
                    <Popup budgetTagsUrl={props.budgetTagsUrl} />
                    <div className="tw-mb-4">
                        <span>
                            {$t('Assigned to:')}{' '}
                            <a className="link" href={modelUrl}>
                                {modelName}
                            </a>
                        </span>
                    </div>
                    <div className="tw-flex tw-flex-col tw-min-h-0 tw-space-y-6">
                        <div
                            className="in-nav horizontal"
                            data-tabs-active-classes="active"
                            data-tabs-inactive-classes="inactive"
                            data-default-tab-id="edit-packs-tab"
                            data-tabs-toggle="#packs-tab-content"
                            role="tablist"
                            id="packs-tabs"
                        >
                            <button
                                className="in-nav__item"
                                id="simple-packs-tab"
                                data-tabs-target="#simple-packs"
                                type="button"
                                role="tab"
                                aria-controls="simple-packs"
                                aria-selected="false"
                            >
                                {$t('Simple Expense Packs')}
                            </button>
                            <button
                                className="in-nav__item"
                                id="contractor-packs-tab"
                                data-tabs-target="#contractor-packs"
                                type="button"
                                role="tab"
                                aria-controls="contractor-packs"
                                aria-selected="false"
                            >
                                {$t('Contractor Expense Packs')}
                            </button>

                            <div className="tw-flex tw-items-center tw-gap-x-1 !tw-ml-auto tw-hidden">{!!window.canSave && <SaveButton />}</div>
                        </div>
                        <div id="packs-tab-content" className="tw-min-h-0">
                            <div id="simple-packs" className="tw-h-full" role="tabpanel" aria-labelledby="simple-packs-tab">
                                <SimplePacks fetchDashboardUrl={props.packsDashboardUrl} />
                            </div>
                            <div id="contractor-packs" className="tw-h-full" role="tabpanel" aria-labelledby="contractor-packs-tab">
                                <ContractorPacks fetchDashboardUrl={props.packsDashboardUrl} />
                            </div>
                        </div>
                    </div>
                </AssignProvider>
            </ApiProvider>
        </div>
    );
}

const SaveButton = () => {
    const apiCall = useContext(PacksDispatchContext);
    const { packs, packItems, venues, simplePackCategories, contractorPackCategories, isSaving, processedAction, setProcessedAction, relations } =
        useContext(PacksContext);
    const handleSaveAssigns = useCallback((e) => {
        if (isSaving) return; // Prevent multiple clicks if already loading
        const payload = { packs, packItems, venues, simplePackCategories, contractorPackCategories, processedAction, setProcessedAction, relations };
        if (budgetIsLocked) {
            processAjaxConfirmation(() => {
                apiCall('save', payload);
            });
        } else {
            apiCall('save', payload);
        }
    });
    return (
        <Button small variant="primary" className="pack__save_button" type="button" disabled={isSaving} onClick={handleSaveAssigns}>
            {$t('Save assigns')}
        </Button>
    );
};

if (document.getElementById('ExpensePackApp')) {
    var rootEl = document.getElementById('ExpensePackApp'); // data attributes below help us
    ReactDOM.render(
        <App>
            <ExpensePackApp
                dividerH={rootEl.getAttribute('data-dividerH')}
                event={event}
                selectedVenueId={selectedVenueId}
                packsDashboardUrl={packsDashboardUrl}
                budgetTagsUrl={rootEl.getAttribute('data-budget-tags-url')}
            />
        </App>,
        rootEl,
    );
}
